import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-custom-blocks-cta",
    templateUrl: "./custom-blocks-cta.component.html",
    styleUrl: "./custom-blocks-cta.component.scss",
    standalone: false,
})
export class CustomBlocksCtaComponent {
    constructor(private router: Router) {}

    public navigateToDesigner() {
        this.router.navigate(["/designer"]);
    }

    public navigateToCustomizePage() {
        this.router.navigate(["/products"], { queryParams: { category: "block" } });
    }
}
